var exports = {
  "tB": "ApplicationDetail.module__page___ZzBwej",
  "Vr": "ApplicationDetail.module__pageHeader___ZzBwej",
  "d1": "ApplicationDetail.module__heroCard___ZzBwej",
  "CI": "ApplicationDetail.module__heroTop___ZzBwej",
  "ZY": "ApplicationDetail.module__heroTitle___ZzBwej",
  "Uz": "ApplicationDetail.module__metaInput___ZzBwej",
  "WA": "ApplicationDetail.module__detailGrid___ZzBwej",
  "fP": "ApplicationDetail.module__columnStack___ZzBwej",
  "E7": "ApplicationDetail.module__sectionSpacer___ZzBwej",
  "Nr": "ApplicationDetail.module__card___ZzBwej",
  "Wg": "ApplicationDetail.module__cardDanger___ZzBwej",
  "MY": "ApplicationDetail.module__cardHeader___ZzBwej",
  "JJ": "ApplicationDetail.module__cardTitle___ZzBwej",
  "Dc": "ApplicationDetail.module__cardSubtitle___ZzBwej",
  "zI": "ApplicationDetail.module__cardBody___ZzBwej",
  "tx": "ApplicationDetail.module__secretRow___ZzBwej",
  "cD": "ApplicationDetail.module__secretActions___ZzBwej",
  "PZ": "ApplicationDetail.module__fieldStack___ZzBwej",
  "rP": "ApplicationDetail.module__redirectList___ZzBwej",
  "bs": "ApplicationDetail.module__redirectRow___ZzBwej",
  "C2": "ApplicationDetail.module__redirectActions___ZzBwej",
  "py": "ApplicationDetail.module__redirectRemoveButton___ZzBwej",
  "t_": "ApplicationDetail.module__createRedirectButton___ZzBwej",
  "PM": "ApplicationDetail.module__scopeGrid___ZzBwej",
  "bk": "ApplicationDetail.module__fieldLabel___ZzBwej",
  "Jb": "ApplicationDetail.module__scopeList___ZzBwej",
  "LR": "ApplicationDetail.module__botPermissionList___ZzBwej",
  "_": "ApplicationDetail.module__scopeItem___ZzBwej",
  "wS": "ApplicationDetail.module__scopeCheckbox___ZzBwej",
  "$o": "ApplicationDetail.module__scopeLabel___ZzBwej",
  "Ud": "ApplicationDetail.module__avatarRow___ZzBwej",
  "_Q": "ApplicationDetail.module__avatarPreview___ZzBwej",
  "rZ": "ApplicationDetail.module__avatarPlaceholder___ZzBwej",
  "Jm": "ApplicationDetail.module__tagRow___ZzBwej",
  "vb": "ApplicationDetail.module__discriminatorInput___ZzBwej",
  "jY": "ApplicationDetail.module__validationBox___ZzBwej",
  "JE": "ApplicationDetail.module__bannerRow___ZzBwej",
  "HF": "ApplicationDetail.module__builderResult___ZzBwej",
  "Ml": "ApplicationDetail.module__loadingState___ZzBwej",
  "cy": "ApplicationDetail.module__helperText___ZzBwej",
  "RJ": "ApplicationDetail.module__dangerContent___ZzBwej",
  "n7": "ApplicationDetail.module__dangerActions___ZzBwej",
  "z3": "ApplicationDetail.module__error___ZzBwej",
  "sM": "ApplicationDetail.module__srOnly___ZzBwej",
};

module.exports = exports;
